import firebase from "./firebaseconn";
import { createUser, getUser } from "../services/userService";
import { withRouter } from "react-router-dom";
import React, { Component } from "react";

import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";

const INVALID_EMAIL_MESSAGE = `Email inválido! Se recebeu este erro é porque provavelmente está a entrar usando 
      uma conta do Facebook que não tem email como contacto primário. Por favor adicione email como contacto 
      primário na sua conta do facebook e espere no mínimo uma hora ou entre usando outro método.`;

class Auth extends Component {
  uiConfig = {
    callbacks: {
      signInSuccessWithAuthResult: async (authResult, redirectUrl) => {
        const providerId = authResult.additionalUserInfo.providerId;

        if (!authResult.user.email) {
          alert(INVALID_EMAIL_MESSAGE);
          window.location = "/logout";
          return false;
        }

        try {
          const user = await getUser(authResult.user.email);

          if (!user) {
            let newUser = {
              id: authResult.user.uid,
              email: authResult.user.email,
            };

            if (providerId === "password" && !authResult.user.emailVerified) {
              authResult.user
                .sendEmailVerification()
                .then(async function () {
                  await alert(
                    `Email de verificação enviado para ${authResult.user.email}. Se tiver dificuladade em encontrar o email, certifique-se de procurar também nas pastas de lixo e spam.`
                  );
                  window.location = "/logout";
                })
                .catch(function (err) {
                  return console.log(err);
                });
            } else if (
              authResult.user.emailVerified ||
              providerId === "facebook.com" ||
              providerId === "gmail.com"
            ) {
              const profile = authResult.additionalUserInfo.profile;
              newUser = { ...newUser, ...addExtraProfileData(profile) };

              // if (providerId === "password") {
              //   const displayNames = authResult.user.displayName.split(" ");

              //   newUser.firstName = displayNames[0];
              //   let lastName = "";
              //   let i;
              //   for (i = 1; i < displayNames; i++)
              //     lastName = lastName + " " + displayNames[i];

              //   newUser.lastName = lastName;
              // }

              await createUser(newUser.email, newUser);
              // return (window.location = "/profile");
              this.props.history.replace({
                pathname: "/howToUse",
                state: { newUser: true },
              });
              return false;
            }
          } else {
            this.props.history.replace({
              pathname: "/home",
            });
            return false;
          }
        } catch (err) {
          console.log(err);
          alert(err.message);
          window.location = "/logout";
        }
        // return true;
        // return false;
      },
    },
    // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
    signInFlow: "redirect",
    // signInSuccessUrl: "/",
    signInOptions: [
      // Leave the lines as is for the providers you want to offer your users.
      firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      {
        provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
        requireDisplayName: false,
      },
    ],
    // Terms of service url.
    // tosUrl: TOS_URL,
    // Privacy policy url.
    // privacyPolicyUrl: TOS_URL
  };

  render() {
    return (
      <StyledFirebaseAuth
        uiConfig={this.uiConfig}
        firebaseAuth={firebase.auth()}
      />
    );
  }
}

// firebase.auth().languageCode = "pt";
// To apply the default browser preference instead of explicitly setting it.
// firebase.auth().useDeviceLanguage();

export default withRouter(Auth);

const addExtraProfileData = function (profileData) {
  const userData = {};
  if (profileData) {
    if (profileData.birthday)
      userData.birthdate = new Date(profileData.birthday);

    if (profileData.gender) {
      if (profileData.gender === "male") userData.gender = "M";
      else if (profileData.gender === "female") userData.gender = "F";
    }

    if (profileData.first_name) userData.firstName = profileData.first_name;
    else if (profileData.given_name)
      userData.firstName = profileData.given_name;

    if (profileData.last_name) userData.lastName = profileData.last_name;
    else if (profileData.family_name)
      userData.lastName = profileData.family_name;
  }
  return userData;
};

export const logout = async function () {
  await firebase.auth().signOut();
};
